import axios from '@/server/axios'


export function queryPartner() {
  return axios({
    url: 'officialWebsite/queryLogo.do',
    method: 'get',
    params: {

    }
  })
}